import InfoModalContentItem from "./InfoModalContentItem";
export default InfoModalContentItem;
